import { render, staticRenderFns } from "./ViewMethodDataExtractionStudyOutcome.vue?vue&type=template&id=46dc754c&scoped=true"
import script from "./ViewMethodDataExtractionStudyOutcome.vue?vue&type=script&lang=js"
export * from "./ViewMethodDataExtractionStudyOutcome.vue?vue&type=script&lang=js"
import style0 from "./ViewMethodDataExtractionStudyOutcome.vue?vue&type=style&index=0&id=46dc754c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc754c",
  null
  
)

export default component.exports